module.exports = __webpack_public_path__ + "img/bestiole_light_short.ad996ccb.png";